import { useEffect, useState } from "react";
import styled from "styled-components";
import StarRating from ".././StarRating";

const Canvas = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StatusGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  vertical-align: middle;
  margin-top: -2em;
  margin-bottom: 1rem;
`;

const DurationAndStarGroup = styled.div`
  display: flex;
  flex-direction: row;
`;

const Duration = styled.div`
  font-weight: 700;
  font-size: 1.6em;
  margin-right: 2rem;
  letter-spacing: 1.2px;
  color: var(--color-grey-900);
`;

const InfoGroup = styled.div`
  display: flex;
  margin-top: 1em;

  align-items: center;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 10px;
  gap: 4px;

  &:not(:last-child) {
    border-right: 1px solid var(--color-witron-blue);
  }
`;

const InfoHeading = styled.div`
  font-size: 0.6em;
  font-weight: 600;
  color: var(--color-witron-blue);
`;

const InfoValue = styled.div`
  font-size: 0.9em;
  font-weight: 500;
  color: var(--color-grey-800);
  min-height: 1em; /* Ensure consistent height */
`;

const Info = styled.div`
  font-weight: 500;
  font-size: 0.9em;
  letter-spacing: 1.2px;
  color: var(--color-grey-700);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Location = styled.div`
  font-size: 1.1em;
  color: var(--color-grey-900);
`;

function DetailsGeneral({ fault }) {
  const [timeDifference, setTimeDifference] = useState(fault.duration);
  console.log("Do I Render?");
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeDifference((prev) => prev + 1000);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const hours = String(Math.floor(timeDifference / (1000 * 60 * 60))).padStart(
    2,
    "0"
  );
  const minutes = String(
    Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60))
  ).padStart(2, "0");
  const seconds = String(
    Math.floor((timeDifference % (1000 * 60)) / 1000)
  ).padStart(2, "0");
  return (
    <Canvas>
      <StatusGroup>
        <DurationAndStarGroup>
          <Duration>{`${hours}:${minutes}:${seconds}`}</Duration>
          <StarRating size={16} />
        </DurationAndStarGroup>
      </StatusGroup>
      <Info>{fault.faultInfo}</Info>
      <Location>{fault.locationRaw}</Location>
      <Info>{fault.faultRawInfo}</Info>
      <InfoGroup>
        <InfoBox>
          <InfoHeading>GC</InfoHeading>
          <InfoValue>{fault.gc}</InfoValue>
        </InfoBox>
        <InfoBox>
          <InfoHeading>LAC</InfoHeading>
          <InfoValue>{fault.lac}</InfoValue>
        </InfoBox>
        <InfoBox>
          <InfoHeading>POS</InfoHeading>
          <InfoValue>{fault.pos || "\u00A0"}</InfoValue>{" "}
        </InfoBox>
      </InfoGroup>
    </Canvas>
  );
}

export default DetailsGeneral;
